<template>
  <div id="customer-tabs" class="customer-tabs i-pl-9">
    <b-nav class="i-secondary-level-menu">
      <b-nav-item
        class="i-text-subheading-2"
        :class="{
          active: $route.name && $route.name.startsWith('customer-overview'),
        }"
        :active="$route.name && $route.name.startsWith('customer-overview')"
        :to="{ name: 'customer-overview' }"
      >
        Documents
      </b-nav-item>
      <b-nav-item
        data-testid="credit-tab"
        class="i-text-subheading-2 d-block position-relative credit-insights-tab"
        :class="{ active: activeCreditRoutes }"
        :active="activeCreditRoutes"
        :to="{ name: 'customer-credit' }"
      >
        Credit Insights
      </b-nav-item>
    </b-nav>
  </div>
</template>

<script>
export default {
  computed: {
    activeCreditRoutes() {
      return (
        this.$route.name?.startsWith('customer-credit') ||
        this.$route.name?.startsWith('customer-credit-granular-insight')
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.customer-tabs {
  border-bottom: 1px solid $light-neutral-50;
  background: $light-neutral-default;
}
</style>
